"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cards = [{
  title: "Consultant spinal neurosurgeons",
  description: "Three neurosurgeons, including Dr Bronius Špakauskas who pioneered minimally invasive spine surgery in Lithuania. Over 40 years of combined surgical experience."
}, {
  title: "Pain specialists with PhDs",
  description: "Six pain management specialists, including doctors with PhDs in anaesthesiology. Every treatment plan is built on clinical evidence."
}, {
  title: "Recover before you fly",
  description: "Post-operative care at a licensed rehabilitation sanatorium, partly covered by HSE. No rush home. Supervised recovery in a resort setting, with professional care throughout."
}, {
  title: "One team. Your whole journey.",
  description: "From your first consultation to your flight home, one coordinated team guides every step. You are never left wondering what comes next."
}];
export default function WhyChoose() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section className="bg-[#eefaf4] pt-4 pb-12 md:pt-8 md:pb-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-default font-bold text-[#264256] text-2xl sm:text-4xl mb-3">
              What Clinic Agatas offers that Ireland cannot.
            </h2>
            <p className="font-default text-muted-foreground text-base max-w-2xl mx-auto">No waiting lists. A dedicated medical team: neurosurgeons, pain specialists and physiotherapists, focused entirely on your recovery.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 items-stretch">
            {cards.map((card, i) => <div key={i} className="bg-white rounded-lg border-0 shadow-md p-6 flex flex-col gap-3 text-left">
                <h3 className="text-[#264256] font-bold text-base md:text-lg font-default leading-snug">
                  {card.title}
                </h3>
                <p className="text-[#264256] leading-relaxed font-default text-sm">
                  {card.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}